export const adminEdit = () => {
    return {
        width: '1050px',
        title: '管理员编辑流程示意',
        height: '350px',
        ranksep: 75,
        nodesep: 30,
        remark:'可编辑信息：甲方项目联系人、合同分类、合同类型、增值金额、返样信息、项目信息',
        nodes: [
            {
                id: 'start',
                data: { number: 20, label: '管理员编辑合同' },
                type: 'rect',
                style: { size: 60, labelMaxWidth: 45, fill: '#D8D839' },
            },
            {
                id: 'contractStatus',
                data: { label: '判定合同状态' },
                type: 'diamond',
                style: { size: 80, labelMaxWidth: 60, fill: '#DF9931' },
            },
            {
                id: 'invoiceStatus',
                data: { label: '合同开票状态' },
                type: 'diamond',
                style: { size: 80, labelMaxWidth: 60, fill: '#DF9931' },
            },
            {
                id: 'error1',
                data: { status: 'error', label: '报错提示' },
                type: 'rect',
                style: { size: [80, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'edit1',
                data: { label: '编辑合同信息' },
                type: 'rect',
                style: { size: [90, 60], labelMaxWidth: 70, },
            },
            {
                id: 'edit2',
                data: {  label: '编辑合同信息，可编辑合同金额' },
                type: 'rect',
                style: { size: [90, 60], labelMaxWidth: 70, },
            },

            {
                id: 'checkProjectItems',
                data: {  label: '编辑内容中是否删除项目管理系统中已存在项目' },
                type: 'diamond',
                style: { size: [140, 80], labelMaxWidth: 85, fill: '#DF9931' }
            },
            {
                id: 'editSuccess',
                data: {  label: '编辑成功' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#3CC457' },
            },
            {
                id: 'error2',
                data: { label: '报错提示' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#eb0b0b' },
            },
            // {
            //     id: 'info',
            //     data: { label: '可编辑信息：甲方项目联系人、合同分类、合同类型、增值金额、返样信息、项目信息' },
            //     type: 'rect',
            //     style: { size: [620, 75], labelMaxWidth: 100, }
            // },
        ],
        edges: [
            {
                source: 'start',
                target: 'contractStatus',
                type: 'line',
            },
            {
                source: 'contractStatus',
                target: 'invoiceStatus',
                type: 'polyline',
                data: { label: '已通过合同' + `\n` + '审批人: 詹海燕' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                source: 'contractStatus',
                target: 'error1',
                type: 'polyline',
                data: { label: '待审核合同或已驳回合同' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                source: 'invoiceStatus',
                target: 'edit1',
                type: 'polyline',
                data: { label: '已完全开票' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                source: 'invoiceStatus',
                target: 'edit2',
                type: 'polyline',
                data: { label: '未完全开票' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                source: 'edit1',
                target: 'checkProjectItems',
                type: 'polyline',
       
            },
            {
                source: 'edit2',
                target: 'checkProjectItems',
                type: 'polyline',
          
            },
            {
                source: 'checkProjectItems',
                target: 'error2',
                type: 'polyline',
                data: { label: '是' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                source: 'checkProjectItems',
                target: 'editSuccess',
                type: 'polyline',
                data: { label: '否' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },

        ],
    };
};